package com.parmartechnologies.core.feature.cart.network

import com.parmartechnologies.core.feature.invoice.model.CustomerInvoice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateCustomerInvoiceResponse(
    @SerialName("payload") val payload: CustomerInvoice?
)